import { render, staticRenderFns } from "./menu-form.vue?vue&type=template&id=6a761c9c&"
import script from "./menu-form.vue?vue&type=script&lang=js&"
export * from "./menu-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a761c9c')) {
      api.createRecord('6a761c9c', component.options)
    } else {
      api.reload('6a761c9c', component.options)
    }
    module.hot.accept("./menu-form.vue?vue&type=template&id=6a761c9c&", function () {
      api.rerender('6a761c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/menu/menu-form.vue"
export default component.exports